import { render, staticRenderFns } from "./BlockListCtaButtonCustom.vue?vue&type=template&id=f83eb8a4&"
import script from "./BlockListCtaButtonCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListCtaButtonCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListCtaButtonCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports